/* hl-atc-busy — hold the add-to-cart button in a busy state from the tap until
   the cart confirms, and swallow anything pressed in between. */
(function () {
  /* Add-to-cart only. Buy-now and the wallet buttons leave for checkout, so
     there is no cart round trip to wait for and a spinner there would be a lie
     about what is happening. */
  var ATC = '[name="add"], .add-to-cart-button, .sticky-add-to-cart__button';
  var SKIP = '.shopify-payment-button, .sticky-add-to-cart__buynow';

  var busy = null;
  var timer = 0;
  var loadTimer = 0;

  var CART_DRAWER = 'dialog[aria-labelledby="cart-drawer-heading"],' +
                    'dialog[cart-summary-sticky],' +
                    'cart-drawer-component dialog';

  function drawer() { return document.querySelector(CART_DRAWER); }

  /* OPEN THE DRAWER ON THE TAP, NOT ON THE ANSWER.
     Owner: "khi click Cart Drawer UI thì phải mở luôn, nếu chưa load xong thì
     sau animation load ... chứ k kiểu click xong chờ load rồi vào r lại load
     lại khó chịu bị double load".

     Measured before this: the drawer opened ~1.5-2.0s after the add-to-cart
     tap, because it waited for POST /cart/add.js and the section re-render. In
     that gap nothing moved, and then the panel and its contents arrived
     together — which reads as one wait followed by a second one.

     Clicking the header's cart button is what opens the drawer, and measured on
     a cart that already has contents it opens in 197ms with NO fetch at all. So
     the tap opens it through that same path, immediately, and the drawer is
     marked as loading until the cart answers. The panel animation and the fetch
     then overlap instead of queueing.

     This supersedes the earlier instruction to keep the shopper on the button
     until the cart confirmed. The button still goes busy — that is what stops a
     second tap adding twice — but it is no longer the thing being waited on. */
  function openDrawerNow() {
    var d = drawer();
    if (d && d.hasAttribute('open')) { markLoading(d); return; }
    var btn = document.querySelector('button[aria-label="Cart"], .header-actions__action[aria-label="Cart"]');
    if (!btn) return;
    btn.click();
    /* The panel is inserted by the theme's own handler, so the flag is set on
       the next frame rather than now. */
    requestAnimationFrame(function () {
      var dd = drawer();
      if (dd) markLoading(dd);
    });
  }

  /* WHICH SIGNAL ENDS THE WAIT, measured rather than assumed. Traced on one
     add-to-cart, times from the tap:

         145ms  theme-drawer:open          (this file opening it)
         327ms  shopify:cart:lines-update  (the cart data has changed)
         437ms  shopify:cart:view
        1315ms  first mutation inside the drawer
        2857ms  last one

     Neither `cart:update` nor a replacement of .cart-drawer__inner ever
     happens — the first version of this waited for both and left the drawer
     dimmed forever. The cart answers at 327ms but the DOM does not catch up for
     another second, so clearing on the event alone would take the skeleton off
     while the old line items were still on screen, which is the flicker this is
     supposed to prevent.

     So it clears on the LINE ITEMS actually changing, debounced past the burst.
     The later mutations are the related rail and the wallet buttons settling;
     waiting for those would hold the skeleton ~600ms longer than the thing the
     shopper is looking at. */
  var settle = 0;
  var itemsObs = null;

  function markLoading(d) {
    d.setAttribute('data-hl-cart-loading', '1');
    clearTimeout(loadTimer);
    /* A release, not a timeout on the cart: if the add fails or emits nothing,
       the shopper must still get a usable drawer rather than a permanent
       skeleton. */
    loadTimer = setTimeout(clearLoading, 8000);

    if (typeof MutationObserver !== 'function') return;
    if (itemsObs) itemsObs.disconnect();
    itemsObs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (!t || !t.closest) continue;
        if (!t.closest('.cart-drawer__items')) continue;
        clearTimeout(settle);
        settle = setTimeout(clearLoading, 220);
        return;
      }
    });
    itemsObs.observe(d, { subtree: true, childList: true });
  }

  function clearLoading() {
    clearTimeout(loadTimer);
    clearTimeout(settle);
    if (itemsObs) { itemsObs.disconnect(); itemsObs = null; }
    var ds = document.querySelectorAll('[data-hl-cart-loading]');
    for (var i = 0; i < ds.length; i++) ds[i].removeAttribute('data-hl-cart-loading');
  }

  function clear() {
    if (!busy) return;
    var b = busy;
    busy = null;
    clearTimeout(timer);
    b.removeAttribute('data-hl-atcb');
    b.removeAttribute('aria-busy');
    b.removeAttribute('aria-disabled');
    var s = b.querySelector('.hl-atcb__spin');
    if (s) s.remove();
  }

  function start(btn) {
    if (busy) return;
    busy = btn;
    btn.setAttribute('data-hl-atcb', '1');
    btn.setAttribute('aria-busy', 'true');
    /* aria-disabled, never the disabled attribute — see the snippet for why
       disabling a name="add" control breaks the request it is part of. */
    btn.setAttribute('aria-disabled', 'true');
    var s = document.createElement('span');
    s.className = 'hl-atcb__spin';
    s.setAttribute('aria-hidden', 'true');
    btn.appendChild(s);

    /* A safety release, not a timeout on the cart. If the add fails, or the
       theme takes a path that emits none of the signals below, the shopper must
       get their button back rather than a permanently spinning one. */
    timer = setTimeout(clear, 12000);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(ATC);
    if (!t || t.closest(SKIP)) return;
    /* A tap that lands while the first one is still working does nothing at all.
       pointer-events already stops most of them; this catches the ones that were
       dispatched from a different element or by the keyboard. */
    if (busy) { e.preventDefault(); e.stopPropagation(); return; }
    start(t);
    /* 2026-09-25 — owner: spin in the button until the product is added, then open
       the drawer. openDrawerNow() (open on the tap, 2026-09-23) is retired; the
       theme's cart-drawer.js opens it when the add resolves, and the drawer
       opening is what releases this button (observer below). */
  }, true);

  /* Released by whichever arrives first. cart:update is the cart having actually
     changed; the drawer opening is the theme declaring the flow finished. Both
     are checked because a quick-add from a collection card fires the first
     without necessarily reaching the second. */
  /* shopify:cart:lines-update is the one this theme actually emits; cart:update
     is kept because the quantity stepper and the upsell snippet dispatch it. The
     BUTTON is released here — the cart has answered, so a second tap is a
     deliberate second add and should be allowed — while the drawer's skeleton
     waits for the markup, which is a different moment. */
  /* lines-update is dispatched at the START of an add (it carries the promise), so
     it cannot release the button any more — the drawer opening does. Its promise
     is the fallback: resolved but no drawer (a cart page, a closed-drawer theme
     setting) releases after a beat; rejected releases at once. */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var pr = e && (e.promise || (e.detail && e.detail.promise));
    if (!pr || typeof pr.then !== 'function') return;
    pr.then(function (r) {
      if (r && r.detail && r.detail.didError) { clear(); return; }
      setTimeout(clear, 1500);
    }, clear);
  });
  ['cart:error', 'shopify:cart:error'].forEach(function (n) {
    document.addEventListener(n, function () { clear(); clearLoading(); });
  });

  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (records) {
      if (!busy) return;
      for (var i = 0; i < records.length; i++) {
        var d = records[i].target;
        if (d.matches && d.matches(CART_DRAWER) && d.hasAttribute('open')) { clear(); return; }
      }
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /* A button that is re-rendered out from under us takes its busy state with it,
     so the module-level reference has to be dropped or clear() would keep
     pointing at a detached node and the next press would be ignored. */
  window.addEventListener('pagehide', clear);
})();
